export class NewsTypeReferenceModel {
    newsTypeCode: string;
    newsTypeName: string;
}